import { useSelector } from 'react-redux';
import { IdeaState } from '@/reducers/idea';

export default function useIdea() {
  const idea = useSelector((state: { idea: IdeaState }) => state.idea.idea);
  const error = useSelector((state: { idea: IdeaState }) => state.idea.error);

  return [idea, error] as const;
}
